import { LandingPage } from './';

export default {
  path: '/dashboard/landingpage',
  name: 'Topics',
  childRoutes: [{ path: 'landingpage', name: 'Landing Page', component: LandingPage, isIndex: true }],
};



// WEBPACK FOOTER //
// ./src/features/landing-page/route.js